export default function clickMap() {
  const map = document.getElementById('c_map');
  if (map === null) return;
  const mapImage = [];
  const mobileMatchMedia = window.matchMedia('screen and (max-width: 979px)');
  const pattern = ['all', 'n', 'e', 'c', 'w'];
  const getCurrentLanguage = () => {
    const availableLanguage = {
      ja: 'jp',
      en: 'en',
      'en-US': 'en',
      'it-IT': 'it',
      'es-ES': 'es',
      'zh-TW': 'tw',
      'ko-KR': 'ko',
      'th-TH': 'th',
      'id-ID': 'in',
      'fr-FR': 'fr',
    };
    const findKey = Object.keys(availableLanguage).find(key => {
      return key === document.documentElement.lang;
    });

    return findKey === undefined ? null : availableLanguage[findKey];
  };

  const directoryJudgment =
    window.paths === undefined
      ? '.'
      : `${window.paths.stylesheet_directory_uri}/frontend/dist`;

  const initMapImage = () => {
    const setUsemap = mobileMatchMedia.matches ? '#imageMapSP' : '#imageMap';
    map.setAttribute('usemap', setUsemap);
    setTimeout(() => {
      $(map).trigger('resize');
    }, 0);

    pattern.forEach((value, index) => {
      if (mobileMatchMedia.matches) {
        mapImage[
          index
        ] = `${directoryJudgment}/img/common/map_${getCurrentLanguage()}_sp.png`;
      } else {
        mapImage[
          index
        ] = `${directoryJudgment}/img/common/map_${getCurrentLanguage()}_pc_${value}.png`;
      }
    });

    map.src = mapImage[0];
  };

  const mapMouseOver = () => {
    const $map = $('[name ^= imageMap] area');
    $map.on('mouseover', event => {
      if (event.currentTarget.classList.contains('link_n')) {
        map.src = mapImage[1];
      } else if (event.currentTarget.classList.contains('link_e')) {
        map.src = mapImage[2];
      } else if (event.currentTarget.classList.contains('link_c')) {
        map.src = mapImage[3];
      } else if (event.currentTarget.classList.contains('link_w')) {
        map.src = mapImage[4];
      }
    });
    $map.on('mouseout', () => {
      map.src = mapImage[0];
    });
  };

  // プラグイン用コード
  $('img[usemap]').rwdImageMaps();
  // 実行
  initMapImage();
  mapMouseOver();
  mobileMatchMedia.addListener(() => {
    initMapImage();
  });
}
